import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useLogowanie } from '../context/KontekstLogowania';

export default function ChronionaTrasa({ children, uprawnienie }) {
  const { uzytkownik, ladowanie, maUprawnienie } = useLogowanie();

  if (ladowanie) {
    return <Box sx={{ minHeight: '50vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;
  }
  if (!uzytkownik) return <Navigate to="/logowanie" replace />;
  if (uprawnienie && !maUprawnienie(uprawnienie)) return <Navigate to="/srodki-trwale" replace />;
  return children;
}
